(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sn-announce"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var msgs = root.querySelectorAll('[data-sn-announce-msg]');
    if (msgs.length < 2) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0, paused = false;
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });
    setInterval(function () {
      if (paused) return;
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, 4000);
  }
  function all(scope) { (scope || document).querySelectorAll('[data-sn-announce]').forEach(init); }
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); });
  else all();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sn-buy"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.bundlesReady) return;
    var bundles = root.querySelectorAll('[data-sn-bundle]');
    if (!bundles.length) return;
    root.dataset.bundlesReady = '1';
    var qty = root.querySelector('[data-sn-qty-input]');
    var stickyPrice = root.querySelector('[data-sn-sticky-price]');
    var slotsWrap = root.querySelector('[data-sn-slots]');
    var slots = root.querySelectorAll('[data-sn-slot]');
    var optTitle = root.querySelector('[data-sn-opt-title]');
    var form = root.querySelector('[data-sn-form]');
    var idInput = root.querySelector('[data-sn-variant-id]');
    var addBtn = root.querySelector('[data-sn-add]');
    var live = root.querySelector('[data-sn-live]');
    var current = 1;

    function apply() {
      bundles.forEach(function (b) {
        if (!b.checked) return;
        current = parseInt(b.value, 10) || 1;
        if (qty) qty.value = current;
        if (stickyPrice && b.dataset.total) stickyPrice.textContent = b.dataset.total;
      });
      slots.forEach(function (f) { f.hidden = parseInt(f.dataset.snSlot, 10) > current; });
      if (optTitle && slotsWrap) {
        optTitle.textContent = current > 1 ? slotsWrap.dataset.optLabel + ' zestawu 1' : optTitle.dataset.default;
      }
    }
    bundles.forEach(function (b) { b.addEventListener('change', apply); });
    root.querySelectorAll('[data-sn-option]').forEach(function (o) {
      o.addEventListener('change', function () { setTimeout(apply, 0); });
    });
    slots.forEach(function (f) {
      f.addEventListener('change', function (e) {
        var v = f.querySelector('[data-sn-slot-value]');
        if (v && e.target.dataset.label) v.textContent = e.target.dataset.label;
      });
    });
    apply();

    if (form && slotsWrap) {
      form.addEventListener('submit', function (e) {
        if (current < 2) return;
        e.preventDefault();
        var counts = {};
        function add(id) { if (id) counts[id] = (counts[id] || 0) + 1; }
        add(idInput && idInput.value);
        slots.forEach(function (f) {
          if (f.hidden) return;
          var c = f.querySelector('input:checked');
          add(c ? c.value : (idInput && idInput.value));
        });
        var items = Object.keys(counts).map(function (id) { return { id: parseInt(id, 10), quantity: counts[id] }; });
        fetch(slotsWrap.dataset.addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw new Error('add');
          window.location.href = slotsWrap.dataset.cartUrl;
        }).catch(function () {
          if (addBtn) { addBtn.removeAttribute('aria-busy'); addBtn.textContent = addBtn.dataset.labelAdd; }
          if (live) live.textContent = 'Nie udało się dodać do koszyka. Spróbuj ponownie.';
          alertBox();
        });
      });
    }
    function alertBox() {
      var box = root.querySelector('.sn-slots__error');
      if (!box) {
        box = document.createElement('p');
        box.className = 'sn-slots__error';
        box.setAttribute('role', 'status');
        slotsWrap.appendChild(box);
      }
      box.textContent = 'Nie udało się dodać do koszyka – któryś kolor może być chwilowo niedostępny. Spróbuj ponownie.';
    }
  }
  function all(scope) { (scope || document).querySelectorAll('[data-sn-buy]').forEach(init); }
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); });
  else all();
})();

  } catch(e) { console.error(e); }
})();
})();
